import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';
import Classes from './Navbar.module.css';
import Logo from '../Logo/Logo';
import { scrollToElement } from '../../../../../utils/scrollToElement';
import MoreDropDown from './Comp/MoreDropdown';

export default function Navbar() {
    const navigateTo = useNavigate();
    const location = useLocation();
    const [activePage, setActivePage] = useState(location.pathname);

    useEffect(() => {
        setActivePage(location.pathname);
    }, [location.pathname]);

    const [width, setWidth] = useState(
        typeof window !== 'undefined' ? window.innerWidth : 0
    );

    const handleScrollOrNavigate = (id, offset = 0) => {
        if (location.pathname !== '/') {
            navigateTo('/', { state: { scrollTo: { id, offset } } });
        } else {
            scrollToElement(id, offset);
        }
    };

    useEffect(() => {
        function handleResize() {
            setWidth(window.innerWidth);
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const navigateTologin = () => navigateTo('/login');

    return (
        <motion.div className={`${Classes.navbar} layoutPadding`} >
            <div className={Classes.gridLeft} >
                <div onClick={() => { navigateTo('/') }} style={{ textDecoration: 'none', cursor: 'pointer' }} >
                    <div>
                        <Logo alwaysShowText={true} />
                    </div>
                </div>
            </div>
            <ul>
                {width >= 400 &&
                    <li
                        className={Classes.navActive}
                        onClick={() => { navigateTo('/') }}
                    >
                        <h5> Home </h5>
                    </li>
                }
                <li
                    onClick={() => handleScrollOrNavigate('features', 20)}
                    className={Classes.navActive}
                >
                    <h5> Features </h5>
                </li>
                <li
                    onClick={() => handleScrollOrNavigate('pricing', 25)}
                    className={Classes.navActive}
                >
                    <h5> Pricing </h5>
                </li>
                {width >= 350 &&
                    <li
                        onClick={() => handleScrollOrNavigate('faq', 70)}
                        className={Classes.navActive}
                    >
                        <h5> FAQ </h5>
                    </li>
                }
            </ul>
            <div className={Classes.gridRight}>
                <div className={Classes.ctaRow}>
                    <button className={Classes.secondaryBtn} onClick={navigateTologin}>
                        Sign in
                    </button>
                    <MoreDropDown />
                </div>
            </div>
        </motion.div >
    );
}
